import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { GroupQuestion } from '../models/group-question';

@Component({
  selector: 'lms-mars1-question-create',
  templateUrl: './mars1-question-create.component.html',
  styleUrls: ['./mars1-question-create.component.scss']
})
export class Mars1QuestionCreateComponent implements OnInit, OnDestroy {
  public paramsSubscription: any;
  public groupId: any;

  constructor(
    public location: Location,
    public translate: TranslateService,
    public titleService: Title,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('pageTitle.questions') + ' - ' + this.translate.instant('pageTitle.gamelearn')
    );
    this.paramsSubscription = this.route.queryParamMap.subscribe((queryParams: ParamMap) => {
      this.groupId = queryParams.get('groupId');
    });
  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }

  onSave(question: GroupQuestion) {
    this.location.back();
  }

  cancel() {
    this.location.back();
  }
}
